import { useCallback, useEffect } from "react";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { usePrefs } from "@/context/PrefsContext";
import { TOURS } from "@/content/guias";

// Tour guiado por pantalla (Prompt 19). Arranca solo la primera vez que el usuario entra a una
// pantalla con tour; se puede relanzar desde el botón de Ayuda (evento "trebol:launch-tour").
export function useScreenTour(screenKey) {
  const { toursVistos, markTourSeen, ready } = usePrefs();

  const launch = useCallback(() => {
    const steps = (TOURS[screenKey] || []).filter((s) => document.querySelector(s.element));
    if (steps.length === 0) return;
    const driverObj = driver({
      showProgress: true,
      progressText: "{{current}} de {{total}}",
      nextBtnText: "Siguiente",
      prevBtnText: "Atrás",
      doneBtnText: "Listo",
      steps,
      onDestroyStarted: () => {
        markTourSeen(screenKey);
        driverObj.destroy();
      },
    });
    driverObj.drive();
  }, [screenKey, markTourSeen]);

  useEffect(() => {
    if (!ready) return;
    if (toursVistos[screenKey]) return;
    const t = setTimeout(launch, 700);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, screenKey]);

  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.screen === screenKey) launch();
    };
    window.addEventListener("trebol:launch-tour", handler);
    return () => window.removeEventListener("trebol:launch-tour", handler);
  }, [screenKey, launch]);
}
